import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN: MijnRoute = {
    path: 'toegangsnaam-wachtwoord-aanvragen',
    navigationEvent: 'toToegangsnaamWachtwoordAanvragen',
    regex: /^\/zelf-regelen\/toegangsnaam-wachtwoord-aanvragen$/,
    webcomponent: 'mijn-toegangsnaam-wachtwoord-aanvragen-webcomponent'
};
